import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const webSetupSlice = createSlice({
  name: "webSetup",
  initialState: {
    webSetupData: [],
    isError: false,
  },

  reducers: {
    fetchWebSetupSuccess: (state, action) => {
      state.isError = false;
      state.webSetupData = action.payload;
    },
    fetchWebSetupFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchWebSetupSuccess, fetchWebSetupFailure } =
  webSetupSlice.actions;

export const fetchWebSetup = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/config`);
    dispatch(fetchWebSetupSuccess(response.data.general_setup)); 
  } catch (error) {
    dispatch(fetchWebSetupFailure());
  }
};

export default webSetupSlice.reducer;
